export default "__VITE_ASSET__BsZ6A$ds__"